import fetch from '../../api/fetch';
import { REDUX_ACTIONS } from '../../shared/config/constants';
import { parseError } from '../../utils/fetchErrorParser';
import { modifyMetricData } from '../../utils/getMetrics';
import store from '../store';
import { enqueueSnackbar } from './snackbar';

export const listWellboreMudprofile = (payload, loader, loaderFalse) => (dispatch) => {
  dispatch({
    type: REDUX_ACTIONS.WELLBORE_MUDPROFILE_LIST_LOADING,
  });
  const body = {
    query: {
      wellsInfoId: payload.wellsInfoId,
    }
  };
  return fetch
    .post('hydraulicsRuns/mudProfiles/fetch', body)
    .then((result) => {
      if (!result.ok) {
        return Promise.reject(result);
      }
      return result.json();
    })
    .then((data) => {
      const { currentUser } = store.getState();
      const { data: wellImportMuds, units } = data;
      const currentUnit = currentUser?.preferences?.unitSystem;
      units.profiles = units;

      const convertedProfile = (mudItem) => {
        let modifiedPipeData = [];
        let modifiedAnnData = [];
        if (mudItem?.mud_profile?.profile?.pipe?.length > 0) {
          modifiedPipeData = modifyMetricData(mudItem.mud_profile.profile.pipe, units.profiles, currentUnit);
        }
        if (mudItem?.mud_profile?.profile?.annular?.length > 0) {
          modifiedAnnData = modifyMetricData(mudItem.mud_profile.profile.annular, units.profiles, currentUnit);
        }
        if (!mudItem?.mud_profile?.profile?.pipe?.length && !mudItem?.mud_profile?.profile?.annular?.length) {
          return { pipe: [], annular: [] };
        } else {
          return { pipe: modifiedPipeData, annular: modifiedAnnData };
        }
      };

      const convertedWellImportMuds = wellImportMuds.map((mudItem) => ({
        ...mudItem,
        well_init: {
          pipe: modifyMetricData(mudItem?.well_init?.pipe || [], units.profiles, currentUnit),
          annular: modifyMetricData(mudItem?.well_init?.annular || [], units.profiles, currentUnit)
        },
        mud_profile: {
          ...mudItem.mud_profile,
          profile: convertedProfile(mudItem)
        },
      }));

      dispatch({
        type: REDUX_ACTIONS.WELLBORE_MUDPROFILE_LIST_SUCCESS,
        payload: {
          data: convertedWellImportMuds,
          paginatedElements: convertedWellImportMuds.length,
          units: data.units
        },
      });
      loader();
    })
    .catch(async (error) => {
      const errorMessage = await parseError(error);
      dispatch(
        enqueueSnackbar(
          errorMessage,
          'error',
          new Date().getTime() + Math.random()
        )
      );
      dispatch({
        type: REDUX_ACTIONS.WELLBORE_MUDPROFILE_LIST_ERROR,
        payload: { ...error, message: 'Error' },
      });
      loaderFalse();
    });
};
